import { TIME_RANGES } from '_constants';

export default {
  DAY: TIME_RANGES.DAY,
  WEEK: TIME_RANGES.WEEK,
};
